import { Modal } from "@mui/material";
import { ModalContent } from "../../components/ModalBasic/style";

type IModalBasic = {
    open: boolean;
    handleClose: () => void;
    children: JSX.Element;
}


export function CommonModal({ open, handleClose, children }: IModalBasic) {
  return (
    <Modal
      open={ open }
      onClose={ handleClose }
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={ {
        zIndex: 1400
      } }
    >
      <ModalContent>
        { children }
      </ModalContent>
    </Modal>
  );
}
